(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback(){this.header=document.querySelector('.section-header');this.currentScrollTop=0;this.onScrollHandler=this.onScroll.bind(this);window.addEventListener('scroll',this.onScrollHandler,false);this.setHeaderHeight();}
  setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);}
  disconnectedCallback(){window.removeEventListener('scroll',this.onScrollHandler);}
  onScroll(){if(this.preventHide)return;if(this.querySelector('details-modal.header__search details[open]')){this.header.classList.remove('shopify-section-header-hidden');return;}const y=window.pageYOffset||document.documentElement.scrollTop;if(y>this.currentScrollTop&&y>this.header.offsetHeight){this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');}else if(y<this.currentScrollTop){this.header.classList.remove('shopify-section-header-hidden');this.header.classList.add('shopify-section-header-sticky');}if(y<=0)this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky');this.currentScrollTop=y;}
}
customElements.define('sticky-header',StickyHeader);

function scrollToFlagDesigner(){
  const heading=document.querySelector('#design-your-flag, #design-your-custom-flag')||[...document.querySelectorAll('.hfd__title')].find(el=>/design your custom flag/i.test(el.textContent||''));
  if(!heading)return false;
  heading.id=heading.id||'design-your-custom-flag';
  heading.style.scrollMarginTop='24px';
  heading.scrollIntoView({behavior:'smooth',block:'start'});
  return true;
}

const NAV_FLAG_SNAPSHOT_KEY='2in1flags:nav-flag:snapshot:v1';

function readNavFlagSnapshot(){
  try{
    const snapshot=JSON.parse(localStorage.getItem(NAV_FLAG_SNAPSHOT_KEY)||'null');
    return snapshot&&snapshot.markup&&snapshot.width&&snapshot.height?snapshot:null;
  }catch(_){return null;}
}

function captureNavFlagSnapshot(){
  const preview=document.querySelector('[data-hfd] [data-preview]');
  if(!preview)return null;
  const width=preview.clientWidth;
  const height=preview.clientHeight;
  const markup=preview.innerHTML;
  if(!markup||!width||!height)return null;
  const snapshot={markup,width,height};
  try{localStorage.setItem(NAV_FLAG_SNAPSHOT_KEY,JSON.stringify(snapshot));}catch(_){}
  return snapshot;
}

function renderNavFlagSnapshot(snapshot){
  const mini=document.querySelector('[data-nav-mini-flag]');
  if(!mini||!snapshot||!mini.clientWidth||!mini.clientHeight)return;
  const frame=document.createElement('span');
  const scale=Math.min(mini.clientWidth/snapshot.width,mini.clientHeight/snapshot.height);
  frame.className='twoinone-design-mini__rendered';
  frame.style.width=`${snapshot.width}px`;
  frame.style.height=`${snapshot.height}px`;
  frame.style.left=`${(mini.clientWidth-snapshot.width*scale)/2}px`;
  frame.style.top=`${(mini.clientHeight-snapshot.height*scale)/2}px`;
  frame.style.transform=`scale(${scale})`;
  frame.innerHTML=snapshot.markup;
  frame.querySelectorAll('[data-preview]').forEach(element=>element.removeAttribute('data-preview'));
  mini.replaceChildren(frame);
}

let lastNavRenderKey='';
function syncNavMiniFlag(){
  const preview=document.querySelector('[data-hfd] [data-preview]');
  const mini=document.querySelector('[data-nav-mini-flag]');
  const markup=preview?.innerHTML||'';
  const key=`${mini?.clientWidth||0}x${mini?.clientHeight||0}:${preview?.clientWidth||0}x${preview?.clientHeight||0}:${markup}`;
  if(key===lastNavRenderKey)return;
  lastNavRenderKey=key;
  const live=captureNavFlagSnapshot();
  renderNavFlagSnapshot(live||readNavFlagSnapshot());
}

let navMiniRaf=0;
function isLivePan(event){
  if(document.querySelector('[data-hfd] .is-panning'))return true;
  return event?.type==='flag:image-adjust-state'&&!event.detail?.print;
}
function scheduleNavMiniFlag(event){
  if(isLivePan(event))return;
  if(navMiniRaf)cancelAnimationFrame(navMiniRaf);
  navMiniRaf=requestAnimationFrame(()=>{navMiniRaf=0;syncNavMiniFlag();});
}

function closeMobileMenu(event){
  const drawer=document.querySelector('header-drawer');
  const details=drawer?.querySelector('#Details-menu-drawer-container');
  if(!drawer||!details?.open)return false;
  const summary=details.querySelector('summary');
  if(summary)summary.setAttribute('aria-expanded','false');
  drawer.closeMenuDrawer(event,summary||drawer);
  return true;
}

document.addEventListener('click',event=>{
  const button=event.target.closest('[data-design-scroll]');
  if(!button)return;
  if(scrollToFlagDesigner()){
    event.preventDefault();
    if(closeMobileMenu(event))setTimeout(scrollToFlagDesigner,450);
    return;
  }
  const url=new URL(button.getAttribute('href')||'/',location.origin);
  url.searchParams.set('scroll','designer');
  const design=new URLSearchParams(location.search).get('design');
  if(design)url.searchParams.set('design',design);
  if(url.href===location.href){
    event.preventDefault();
    return;
  }
  button.href=url.pathname+url.search+url.hash;
});

['flag:design-change','flag:order-change','flag:upload-state','flag:focus-state','flag:image-adjust-state','flag:library-rendered'].forEach(name=>document.addEventListener(name,scheduleNavMiniFlag));
window.addEventListener('storage',event=>{if(event.key===NAV_FLAG_SNAPSHOT_KEY)scheduleNavMiniFlag();});
window.addEventListener('pagehide',captureNavFlagSnapshot);

document.addEventListener('DOMContentLoaded',()=>{
  const heading=[...document.querySelectorAll('.hfd__title')].find(el=>el.textContent.trim()==='Design Your Custom Flag');
  if(heading){heading.id='design-your-custom-flag';heading.style.scrollMarginTop='24px';}
  const preview=document.querySelector('[data-hfd] [data-preview]');
  const mini=document.querySelector('[data-nav-mini-flag]');
  if(preview){new MutationObserver(()=>scheduleNavMiniFlag()).observe(preview,{subtree:true,childList:true});}
  if(window.ResizeObserver){const ro=new ResizeObserver(scheduleNavMiniFlag);if(preview)ro.observe(preview);if(mini)ro.observe(mini);}
  scheduleNavMiniFlag();
  if(new URLSearchParams(window.location.search).get('scroll')==='designer'){
    setTimeout(scrollToFlagDesigner,100);
  }
});

  } catch(e) { console.error(e); }
})();
})();
